import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'formatDate' })
export class FormatDatePipe implements PipeTransform {
    /** `format` usa tokens Luxon (dd/LL/yyyy HH:mm). */
    transform(value: string | Date | undefined | null, format: string = 'dd/LL/yyyy HH:mm'): string {
        if (!value) {
            return '-'; // Valor padrão para datas ausentes
        }

        // Interpreta a data como UTC (strings sem offset) e converte para o horário local
        const dateTime = typeof value === 'string'
            ? DateTime.fromISO(value, { zone: 'utc' }).toLocal()
            : DateTime.fromJSDate(value);
        return dateTime.isValid ? dateTime.toFormat(format) : '-';
    }
}
